// extracted by mini-css-extract-plugin
export default {"card":"ProjectCard_card__RF7Re","cardContentBox":"ProjectCard_cardContentBox__Kkv-n"};